import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  MatOptionModule,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { FileUploaderComponent } from '../components/file-uploader/file-uploader.component';
import { FooterComponent } from '../components/footer/footer.component';
import { PageNotFoundComponent } from '../components/page-not-found/page-not-found/page-not-found.component';
import { DatePerZonePipe } from '../pips/date.pipe';
import { EnumKeyValueListPipe } from '../pips/enumList.pipe';
// import { AgmCoreModule } from '@agm/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { FileSaverModule } from 'ngx-filesaver';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { TruncatePipe } from '../pips/truncate.pipe';
import { HijriCalendarComponent } from '../components/hijri-calendar/hijri-calendar.component';
import { CalendarModule } from 'primeng/calendar';
import { SidebarModule } from 'primeng/sidebar';
import { TableSearchComponent } from '../components/table-search/table-search.component';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TabViewModule } from 'primeng/tabview';
import { FileUploadModule } from 'primeng/fileupload';
import { RadioButtonModule } from 'primeng/radiobutton';
import { StepsModule } from 'primeng/steps';
import { ClientInfoComponent } from '../components/client-info/client-info.component';
import { ConfirmDeletingComponent } from '../components/confirm-deleting/confirm-deleting.component';
import { OtpInputComponent } from '../components/otp-input/otp-input.component';
import { PdfPreviewDialogComponent } from '../components/pdf-preview-dialog/pdf-preview-dialog.component';
import { SimahApproveComponent } from '../components/simahapprove/simahapprove.component';
import { CurrencyFormatDirective } from '../directive/currency-format.directive';
import { NumbersOnlyDirective } from '../directive/numbers-only.directive';
import { TimezoneInterceptor } from '../interceptors/time-zone-Interceptor';
import { AuthInterceptor } from 'src/app/core/common-services/interceptor.service';
import { DialogModule } from 'primeng/dialog';
import { MoyasarPaymentComponent } from '../components/moyasar-payment/moyasar-payment.component';
import { FixAnyDatePipe } from '../pips/FixAnyDatePipe';
import { RoundNumberPipe } from '../pips/RoundNumberPipe';
import { ApplicantIdentityComponent } from 'src/app/features/Borrower/applyfund/steps/applicant-identity/applicant-identity.component';
import { NationalAddressComponent } from 'src/app/features/Borrower/applyfund/steps/national-address/national-address.component';
import { ApplicantStep1ComplianceComponent } from 'src/app/features/Borrower/applyfund/steps/applicant-step1-compliance/applicant-step1-compliance.component';
import { LanguageToggleComponent } from '../components/language-toggle/language-toggle.component';


@NgModule({
  declarations: [
    EnumKeyValueListPipe,
    FixAnyDatePipe ,
    RoundNumberPipe,
    PageNotFoundComponent,
    FooterComponent,
    DatePerZonePipe,
    FileUploaderComponent,
    NumbersOnlyDirective,
    CurrencyFormatDirective,
    OtpInputComponent,
    ConfirmDeletingComponent,
    PdfPreviewDialogComponent,
    ConfirmDialogComponent,
    TruncatePipe,
    HijriCalendarComponent,
    TableSearchComponent,
    SimahApproveComponent,
    ClientInfoComponent,
    MoyasarPaymentComponent,
    ApplicantIdentityComponent,
    NationalAddressComponent,
    ApplicantStep1ComplianceComponent,
    LanguageToggleComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    MatInputModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatOptionModule,
    MatRadioModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatStepperModule,
    //  GoogleMapsModule,
    NgSelectModule,
    MatAutocompleteModule,
    TranslateModule,
    CalendarModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    CheckboxModule,
    DropdownModule,
    TabViewModule,
    FileUploadModule,
    RadioButtonModule,
    StepsModule,
    ConfirmDialogModule,
    DividerModule,
    TableModule,
    ProgressSpinnerModule,
    SidebarModule,
  DialogModule,
    //  NgxMatDatetimePickerModule,
    //  NgxMatTimepickerModule,
    //  NgxMatNativeDateModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    FooterComponent,
    DatePerZonePipe,
    FixAnyDatePipe ,
    RoundNumberPipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatCheckboxModule,
    EnumKeyValueListPipe,
    MatExpansionModule,
    MatPaginatorModule,
    MatTabsModule,
    MatProgressBarModule,
    MatOptionModule,
    MatRadioModule,
    MatStepperModule,
    FileUploaderComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    NumbersOnlyDirective,
    CurrencyFormatDirective,
    // AgmCoreModule,
    // GoogleMapsModule,
    NgSelectModule,
    MatAutocompleteModule,
    OtpInputComponent,
    ConfirmDeletingComponent,
    TranslateModule,
    PdfPreviewDialogComponent,
    FileSaverModule,
    TruncatePipe,
    HijriCalendarComponent,
    SidebarModule,
    ButtonModule,
    TableSearchComponent,
    SimahApproveComponent,
    TabViewModule,
    ConfirmDialogModule,
    DividerModule,
    TableModule,
    ProgressSpinnerModule,
    CheckboxModule,
    CalendarModule,
    DropdownModule,
    FileUploadModule,
    RadioButtonModule,
    StepsModule,
    ClientInfoComponent,
    DialogModule,
    MoyasarPaymentComponent,
    ApplicantIdentityComponent,
    NationalAddressComponent,
    ApplicantStep1ComplianceComponent,
    LanguageToggleComponent,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: HTTP_INTERCEPTORS, useClass: TimezoneInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },

    DatePerZonePipe,FixAnyDatePipe ,RoundNumberPipe
  ],
})
export class SharedModule {}
